import { render, staticRenderFns } from "./GeneralAlert.vue?vue&type=template&id=35f5ae4a&"
import script from "./GeneralAlert.vue?vue&type=script&lang=ts&"
export * from "./GeneralAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports